module.exports = __webpack_public_path__ + "static/media/elixir-arsign.a9b9ac3d.pdf";